export const getDateObj = (initDate, options = {}) => {
  if (!initDate) return {};

  const localDate = new Date(initDate);
  const utcDate = new Date(
    localDate.getTime() + localDate.getTimezoneOffset() * 60000
  );

  if (options.addMonths && options.addMonths > 0) {
    utcDate.setMonth(utcDate.getMonth() + options.addMonths);
  }

  const day = utcDate.getDate();
  const longMonth = utcDate.toLocaleString('default', { month: 'long' });
  const shortMonth = utcDate.toLocaleString('default', { month: 'short' });
  const monthIndex = utcDate.getMonth();
  const year = utcDate.getFullYear();

  const displayDate = `${longMonth} ${day}, ${year}`;

  return { day, longMonth, shortMonth, monthIndex, year, displayDate };
};

export const compareTwoDates = (date1 , date2)=>{
  const dateFormat1 = new Date(date1);
  const dateFormat2 = new Date(date2);
  if(!isNaN(dateFormat1) && !isNaN(dateFormat2)){
    return dateFormat1 <= dateFormat2;
  }
  return false;
};

export const calculateAge = (date)=> {
  const dateFormat = new Date(date);
  const cureentDateFormat = new Date();
  let age = cureentDateFormat.getFullYear() - dateFormat.getFullYear();
  const months = cureentDateFormat.getMonth() - dateFormat.getMonth();
  if (months < 0 || (months === 0 && cureentDateFormat.getDate() < dateFormat.getDate())) {
      age--;
  }
  return age;
};